

'use client';

import React, { createContext, ReactNode } from 'react';

/**
 * This provider is now a lightweight shell. Its original purpose of managing
 * a global project list has been removed in favor of on-demand data fetching
 * in the components that need it.
 *
 * It remains in the component tree as a placeholder for any future app-wide
 * state that might be needed, but it no longer provides any value.
 */
export const AppContext = createContext<{} | undefined>(undefined);

export function AppProvider({ children }: { children: ReactNode }) {
  return (
    <AppContext.Provider value={{}}>
      {children}
    </AppContext.Provider>
  );
}
